import graphql from '@/api/graphql'
import Queries from '@/api/graphql/queries'

export default {
  getSalesResidential(payload) {
    return graphql
      .request(Queries['StatisticsSalesResidential'], payload)
      .then(data => data.Statistics.sales.residential)
  },
}
